import { render } from "./PageDetail.vue?vue&type=template&id=604c0bcb&ts=true"
import script from "./PageDetail.vue?vue&type=script&lang=ts"
export * from "./PageDetail.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__